<template>
  <div class="menu__body">
    <div class="menu__nav-col" v-if="user.entity_id === 2">
      <ul class="menu__nav">
        <li class="menu__nav-item">
          <template v-if="!isMobile">
            <router-link
              to="/student-schedule"
              class="menu__nav-link"
              :class="{ active: $route.path === '/student-schedule' }"
            >
              <img src="images/Schedule.svg" alt="" class="white" />

              <span>מערכת שעות</span>
            </router-link>
          </template>
          <div
            v-else
            class="menu__nav-link"
            :class="{ active: $route.path === '/student-schedule' }"
            @click="menuItemClick('/student-schedule', 0)"
          >
            <img src="images/Schedule.svg" alt="" class="white" />
            <span>מערכת שעות</span>
          </div>
        </li>
        <li
          class="menu__nav-item"
          :class="{ active: $route.path === '/student-security' }"
        >
          <template v-if="!isMobile">
            <router-link
              to="/student-security"
              class="menu__nav-link"
              :class="{ active: $route.path === '/student-security' }"
            >
              <icon name="menu-new-icon-11" class="white" />
              <span> אישורים</span>
            </router-link>
          </template>
          <div
            v-else
            class="menu__nav-link"
            :class="{ active: $route.path === '/student-security' }"
            @click="menuItemClick('/student-security', 0)"
          >
            <icon name="menu-new-icon-11" class="white" />

            <span> אישורים</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="menu__nav-col" v-if="user.entity_id !== 2">
      <ul class="menu__nav">
        <li class="menu__nav-item">
          <template v-if="!isMobile">
            <router-link
              v-if="
                $perm('student.list', selectedCampus.id) ||
                $perm('student.show', selectedCampus.id)
              "
              to="/administration-tables?tab=administration"
              class="menu__nav-link"
            >
              <!-- to="/administration-tables?tab=administration" -->
              <icon name="menu-new-icon-1" class="white" />
              <span>ראשי</span>
            </router-link>
          </template>
          <div
            v-else
            class="menu__nav-link"
            :class="{ active: $route.path === '/mobile-dashbord' }"
            @click="menuItemClick('/mobile-dashbord', 0)"
          >
            <icon name="menu-new-icon-1" class="white" />
            <span>ראשי</span>
          </div>
        </li>
      </ul>
      <ul
        class="menu__nav"
        v-for="(menu, menuIndex) in newMenu"
        :key="menuIndex"
      >
        <template v-for="(item, index) in menu">
          <li v-if="item.show" :key="index" class="menu__nav-item">
            <component
              :is="!isMobile ? 'router-link' : 'div'"
              :to="item.url"
              class="menu__nav-link"
              :class="{
                active:
                  $route.path === item.url ||
                  $route.name === item.child_url_name
              }"
              active-class="active"
              @click="menuItemClick(item.url, item.showMenuMobile)"
              tabindex="0"
              @keyup.enter="menuItemClick(item.url, item.showMenuMobile)"
            >
              <img
                v-if="item.center"
                :src="
                  item.img.includes('storage')
                    ? '/' + item.img
                    : '/images/centers-default.svg'
                "
                class="white"
                style="width: 24px; height: 24px"
                alt=""
              />
              <icon v-else :name="item.img" class="white" />
              <span>{{ item.name }}</span>
            </component>
          </li>
        </template>
      </ul>
      <div class="menu__user">
        <img
          :src="'/storage/' + (user ? user.img : '-')"
          alt="avatar-placeholder"
          v-avatar-placeholder
        />
      </div>
    </div>
    <div class="menu__body-inner">
      <TheSidebar v-if="user.entity_id !== 2" />
      <a href="" class="menu__exit">
        <div v-if="user" class="menu__exit-title">
          <b>{{ user.full_name }}</b>
          <span>{{ user.position }}, {{ user.department }}</span>
        </div>
        <div
          @click="$emit('logout')"
          tabindex="0"
          @keyup.enter="$emit('logout')"
          class="menu__exit-svg"
        >
          <icon name="menu-new-logout" />
          <div class="tooltip top">יציאה ממערכת</div>
        </div>
      </a>
    </div>
  </div>
</template>
<style>
.menu__exit-svg {
  position: relative;
}
.menu__exit-svg:hover .tooltip {
  opacity: 1;
}
</style>
<script>
import TheSidebar from '@/Components/Layout/TheSidebar';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'NewMenu',
  components: { TheSidebar },

  props: {
    showMenu: {
      type: Boolean,
      default: false
    },
    user: {
      default: false
    }
  },
  computed: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    ...mapState({
      selectedCampus: s => s.settings.selectedCampus
    }),
    ...mapGetters({
      selectedCampusList: 'settings/selectedCampusList'
    }),
    showSidebar() {
      return this.$store.getters['front/getSidebarStatus'];
    },
    newMenu() {
      return [
        [
          {
            name: 'עובדים',
            img: 'menu-new-icon-3',
            url: '/workers-list',
            perm: 'workers',
            child_url_name: 'Worker',
            show: this.$perm('worker_list.show', this.selectedCampus?.id)
          }
        ],
        [
          {
            name: 'תלמידים',
            img: 'menu-new-icon-2',
            url: '/student-list',
            child_url_name: 'StudentEdit',
            perm: 'students',
            show:
              this.$perm('student.list', this.selectedCampus?.id) ||
              this.$perm('student.show', this.selectedCampus?.id) ||
              this.$perm('menu.students', this.selectedCampus?.id),
            showMenuMobile: 1
          },
          {
            name: 'מערכת תלמידים',
            img: 'menu-icon-schedule-student',
            url: '/lessons-all-students',
            perm: 'students',
            show:
              this.$perm('student.list', this.selectedCampus?.id) ||
              this.$perm('student.show', this.selectedCampus?.id) ||
              this.$perm('menu.students', this.selectedCampus?.id),
            showMenuMobile: 1
          },
          {
            name: 'תוכניות',
            img: 'projects',
            url: '/projects',
            perm: 'students',
            show:
              this.$perm('student.list', this.selectedCampus?.id) ||
              this.$perm('student.show', this.selectedCampus?.id) ||
              this.$perm('menu.students', this.selectedCampus?.id),
            showMenuMobile: 1
          },
          {
            name: 'נוכחות',
            img: 'menu-new-icon-10',
            url: '/reports',
            perm: 'students',
            show:
              this.$perm('report.list', this.selectedCampus?.id) ||
              this.$perm('report.show', this.selectedCampus?.id)
          },
          {
            name: 'אישורים',
            img: 'menu-new-icon-11',
            url: '/students-security',
            perm: 'students',
            show: this.$perm('student.view_parents', this.selectedCampus?.id)
          },
          {
            name: 'אירועים',
            img: 'menu-new-icon-12',
            url: '/incident-blanks',
            perm: 'students',
            show: this.$perm(
              'student.view_behavior_incidents',
              this.selectedCampus?.id
            )
          }
        ],
        [
          ...this.selectedCampusList.map(item => {
            return {
              center: true,
              name: item.name_menu,
              img: item.icon || 'centers-default',
              url: `/centers/${item.url}/day`,
              perm: 'study-center',
              show: this.$perm(
                'study_center.can_show',
                this.selectedCampus?.id
              ),
              showMenuMobile: 1
            };
          })
        ],
        [
          {
            name: 'אחזקה',
            img: 'menu-new-icon-9',
            url: '/service-orders?status=all',
            perm: 'maintenance',
            show: this.$perm('service_orders.create', this.selectedCampus?.id),
            showMenuMobile: 1
          },
          {
            name: 'ביטחון',
            img: 'menu-new-icon-5',
            url: '/security/student',
            perm: 'security',
            show: this.$perm('security.can_view', this.selectedCampus?.id),
            showMenuMobile: 1
          },
          {
            name: 'מבקרים',
            img: 'menu-new-icon-4',
            url: '/own-permission',
            perm: 'own_permits',
            show: this.$perm('security.can_view', this.selectedCampus?.id)
          }
        ],
        [
          {
            name: 'הגדרות',
            img: 'menu-new-icon-8',
            url: '/settings',
            perm: 'settings',
            show: this.$perm('settings.view', this.selectedCampus.id),
            showMenuMobile: 1
          }
        ]
      ];
    }
  },
  methods: {
    ...mapActions({
      setMenuPart: 'front/setMenuPart',
      setSidebarStatus: 'front/setSidebarStatus'
    }),
    menuItemClick(path, status = 0) {
      if (path === '/service-orders?status=all') {
        this.$router.push({ path: path + '&menu-open=' + status });
      } else {
        this.$router.push({ path: path + '?menu-open=' + status });
      }
      this.setSidebarStatus(status === 1 ? true : false);
    }
  }
};
</script>

<style scoped></style>
